import { render } from "./ModokashiMarketsTalentList.vue?vue&type=template&id=5c0b830b&scoped=true&ts=true&lang=pug"
import script from "./ModokashiMarketsTalentList.vue?vue&type=script&lang=ts"
export * from "./ModokashiMarketsTalentList.vue?vue&type=script&lang=ts"

import "./ModokashiMarketsTalentList.vue?vue&type=style&index=0&id=5c0b830b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0b830b"]])

export default __exports__